import React from "react";
import { Link } from "react-router-dom";
import PriceBox from "./Reusable/PriceBox";

const ListProductsVerticalItem = ({ item }) => {
  const formattedPrice = (price) => {
    const parts = price.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(",");
  };

  function formatUrlString(inputString) {
    // Pretvara sva velika slova u mala
    const lowercaseString = inputString.toLowerCase();

    // Zamjenjuje sve razmake i specijalne karaktere sa -
    const formattedString = lowercaseString
      .replace(/[^\w\s]/gi, "")
      .replace(/\s+/g, "-");

    return formattedString;
  }
  return (
    <div className="product product-widget">
      <figure className="product-media">
        <Link to={`/proizvod/${formatUrlString(item.name)}/${item.id}`}>
          <img src={item?.images?.[0]} alt="Product" width="300" height="338" />
        </Link>
      </figure>
      <div className="product-details">
        <h4 className="product-name">
          <Link to={`/proizvod/${formatUrlString(item.name)}/${item.id}`}>
            {item.name}
          </Link>
        </h4>
        <div className="product-price product-price-holder-custom product-detail-price-custom product-item-vertical-list">
          <PriceBox item={item} />
        </div>
      </div>
    </div>
  );
};

export default ListProductsVerticalItem;
